(function(){

    var sama_property= 'enable_sama',
        VictimForm = VictimController.Form(),
        sama = {},
        PROXIMITY_CAUTION=16000,
        PROXIMITY_WARNING=11000,
        PROXIMITY_DANGER=6000,
        RANGE_CAUTION = [14000,17999],
        RANGE_WARNING =[8000,13999],
        RANGE_DANGER=[0,7999];
    // Controller    
    var StalkerController = {
        elementPrefixId:'',
    };
    // METHODS 
    /**
     * Initialize DOM and Base functionality
     */
    function Render(OriId){
        var flag = veritracks.core.GetOriProperty(OriId?OriId:mEnrolleesData.VictimProfileCurrent.OrganizationId,sama_property);
        // console.log(VictimProfileCurrent,sama_property,flag)
        var FlagHasBeenDisabled = !flag && mEnrolleesData.VictimProfileCurrent.IsStalkerMobile === 1;
        VictimForm.samaCheckbox.toggleGroup(flag);
        VictimForm.samaPhoneNumber.toggleGroup(flag);
        VictimForm.sama.toggleGroup(flag); 
        VictimForm.pair.toggleGroup(!flag);
        if(flag){
            // If Updating Victim and Stalker Mobile is 
            //Display working 
            var isStalkerEnabled = VictimController.IsEditMode?VictimForm.sama.getValue('IsStalkerMobile'): mEnrolleesData.VictimProfileCurrent.IsStalkerMobile;
            ToggleStalker(!!isStalkerEnabled);
            VictimForm.sama.toggleGroup(!!isStalkerEnabled);//Int to Bool
            
        }else {
            ToggleStalker(false);
        }  
        //VictimForm.pair.displayOnly('OffenderId',flag);
    }
    StalkerController.Render = Render;
    StalkerController.sama_property = sama_property;
    window.StalkerController = StalkerController;
    //EVENTS
    function ToggleStalker(flag){
        if(VictimController.IsEditMode){
            if(flag){
                VictimForm.samaCheckbox.Element('IsStalkerMobile').checked = true;
                VictimForm.sama.setValue('ProximityCaution',mEnrolleesData.VictimProfileCurrent.ProximityCaution !== -1?mEnrolleesData.VictimProfileCurrent.ProximityCaution:PROXIMITY_CAUTION);// can not be lower than Warning
                VictimForm.sama.setValue('ProximityWarning',mEnrolleesData.VictimProfileCurrent.ProximityWarning !== -1?mEnrolleesData.VictimProfileCurrent.ProximityWarning:PROXIMITY_WARNING);// can not be higher than Danger or lower than Caution
                VictimForm.sama.setValue('ProximityDanger',mEnrolleesData.VictimProfileCurrent.ProximityDanger !== -1?mEnrolleesData.VictimProfileCurrent.ProximityDanger:PROXIMITY_DANGER);// can not be higher than Caution
                $('#uVictimProfileSamaPhoneNumberEdit').addClass('ValidateRequired');
                $('#uVictimProfileProximityCautionEdit').addClass('Validate ValidateRequired ValidateSuccess');
                $('#uVictimProfileProximityWarningEdit').addClass('Validate ValidateRequired ValidateSuccess');
                $('#uVictimProfileProximityDangerEdit').addClass('Validate ValidateRequired ValidateSuccess');
            }else {
                VictimForm.samaCheckbox.Element('IsStalkerMobile').checked = false;
                // VictimForm.samaPhoneNumber.setValue('SamaPhoneNumber','');
                VictimForm.samaPhoneNumber.setValue('ProximityCaution','');
                VictimForm.samaPhoneNumber.setValue('ProximityDanger','');
                VictimForm.samaPhoneNumber.setValue('ProximityWarning','');
                $('#uVictimProfileSamaPhoneNumberEdit').removeClass('ValidateRequired').removeClass('ValidateError');
                $('#uVictimProfileProximityCautionEdit').removeClass('ValidateRequired').removeClass('ValidateError');
                $('#uVictimProfileProximityWarningEdit').removeClass('ValidateRequired').removeClass('ValidateError');
                $('#uVictimProfileProximityDangerEdit').removeClass('ValidateRequired').removeClass('ValidateError');
                // $('.proximity__error').remove();
                $('#uVictimProfileSamaAssociateEnrolleeId').html(VictimIdLinkFormatter(mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId))
            }
        }
    }
    /**
     * When clicking Enable Stalker Mobile the checkbox will trigger this function OnChange
     */
    function EnableStalkerMobileEdit_OnChange(){
        var state = {
            Old: new OrganizationController(mEnrolleesData.VictimProfileCurrent.OrganizationId),
            New: new OrganizationController(parseInt(VictimForm.detail.getValue('OrganizationId'))),
            IsStalkerMobileEnabled: VictimForm.samaCheckbox.getValue('IsStalkerMobile'),
        };
        
        var IsSamaChecked = VictimForm.samaCheckbox.getValue('IsStalkerMobile');
        if(VictimController.IsEditMode && !IsSamaChecked &&mEnrolleesData.VictimProfileCurrent.IsStalkerMobile === 1){
            StalkerController.modal('Warning',localizeWrapper('cStalkerDisableEnrollee'),localizeWrapper('cOk'),localizeWrapper('cEnrolleeCancel'),null,function(){
                //YEs 
                mEnrolleesData.VictimProfileCurrent.IsStalkerMobile =0;
                Render(state.New.Id);
                ClosePopup();
            },function(){
                VictimForm.samaCheckbox.Element('IsStalkerMobile').checked = true;
                ToggleStalker(true);
                ClosePopup();
            })
            return;
        }
        ToggleStalker(IsSamaChecked);
        VictimForm.sama.toggleGroup(!!IsSamaChecked);//Int to Bool  
    }
    /**
     * 
     */ 
    function uOrganization_OnChange(){
        
        return;
    }

    var _modal = function(_Title,_BodyText,_TextFirst,_TextSecond,_TextThird,_OnFirstButtonClick,_OnSecondButtonClick,_OnThirdButtonClick){
        var lButtonBar = GenerateButtonCommandBar();
        if(_TextFirst){
            lButtonBar.append(GenerateButton(_TextFirst, 'Cancel', _OnFirstButtonClick));
        }
        if(_TextSecond){
            lButtonBar.append(GenerateButton(_TextSecond, 'Cancel', _OnSecondButtonClick));
        }
        if(_TextThird){
            lButtonBar.append(GenerateButton(_TextThird, 'Cancel', _OnThirdButtonClick));
        }
        CloseModal();
        DisplayPopup(_Title, '<div id="uEnrolleeMobileAppWarningPopupHolder">'+_BodyText+'</div>', lButtonBar, true);
    };
    StalkerController.modal = _modal;
    //SAMA failed Popup
    function SAMAPhoneNumberInUse() {
        "use strict";
        var lHtml = [],
            lButtonBar = GenerateButtonCommandBar();
        lButtonBar.append(GenerateButton('Okay', 'Okay', function () {
            ClosePopup();
        }));
        DisplayPopup('Stalker Mobile App Phone Number In Use', '<div id="uEMAPhoneNumberPopupHolder"><p> The Victim Primary Contact Number was not saved because it is already in use by another Victim.</p></div>', lButtonBar, false);
    }
    function CautionSwitchingOrganization() {
        "use strict";
        var lHtml = [],
            lButtonBar = GenerateButtonCommandBar();
        lButtonBar.append(GenerateButton('Okay', 'Okay', function () {
            ClosePopup();
        }));
        DisplayPopup('Warning', '<div id="uEMAPhoneNumberPopupHolder"><p>New Selected Organization support Stalker Mobile, however you may need to pair a new Enrollee.</p></div>', lButtonBar, false);
    }
    StalkerController.PreventPhoneNumberInUse = SAMAPhoneNumberInUse;
    /**
     * Validate if in a Given EnrolleeId will UnPair a device from a Victim-Enrollee relation and Stalker is enabled
     */
    StalkerController.PreventUpdateAssignment = function(_success,_failure){
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
        if(lEnrollee.OrganizationId){
            var OrganizationState = new OrganizationController(lEnrollee.OrganizationId);
            if(mEnrolleesData.OffenderProfileCurrentVictims.length){
                console.log('mEnrolleesData.OffenderProfileCurrent',lEnrollee)
            }
            if(OrganizationState.IsPropertySupported(sama_property)){
                var victims = mEnrolleesData.OffenderProfileCurrentVictims.map(function(i){
                    return VictimIdLinkFormatter(i.Id);
                }).join(',');
                var txt = localizeWrapper('cStalkerPreventUnassignKeepPair').replace('%s',victims);
                _modal('Warning',txt,'Continue','Cancel',null,function(){
                   // OnAccept
                        ClosePopup();
                        _success();
                    },function(){
                        // OnCancel
                        ClosePopup();
                        _failure();
                });
                return true;
            }
            return false;
        }
        return false;
    };
    StalkerController.PreventRemoveAssignment = function(_success,_failure){
        var victims = mEnrolleesData.OffenderProfileCurrentVictims.map(function(i){
            return VictimIdLinkFormatter(i.Id);
        }).join(',');
        var txt = localizeWrapper('cStalkerPreventUnassignUnPair').replace('%s',victims);
        _modal('Warning',txt,'Yes','Cancel',null,function(){
            // OnAccept
            ClosePopup();
            _success();
        },function(){
            // OnCancel
            ClosePopup();
            _failure();
        });
    };
    /**
     * @param  {} aVictimId 
     * @param  {} aEnrolleeId 
     * @param  {} _success
     * @param  {} _failure
     */
    StalkerController.PreventORIChangePairing = function(_success,_failure){
        //SamaAssociateEnrolleeId
        var lVictims = '';
        if( mEnrolleesData.OffenderProfileCurrentVictims){
            lVictims = 'Victim(s):'+ mEnrolleesData.OffenderProfileCurrentVictims.map(function(i){
                return VictimIdLinkFormatter(i.Id);
            }).join(',');
        }else if(mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId){
            lVictims = 'Enrollee '+ EnrolleeIdLinkFormatter(mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId);
        }
        var txt = localizeWrapper('cStalkerORIChange').replace('%s',lVictims) + localizeWrapper('cDoYouWishToProceed');
        _modal('Warning',txt,'Yes','Cancel',null,function(){
            // OnAccept
            ClosePopup();
            _success();
        },function(){
            // OnCancel
            ClosePopup();
            _failure();
        });
    };
    StalkerController.IsEnrolleeSAMAPaired = function(lEnrolleeId){
        var lEnrollee = GetEnrollee(lEnrolleeId);
        if(lEnrollee.OrganizationId){
            var OrganizationState = new OrganizationController(lEnrollee.OrganizationId);
            if(mEnrolleesData.OffenderProfileCurrentVictims.length){
                console.log('mEnrolleesData.OffenderProfileCurrent',lEnrollee)
            }
            if(mEnrolleesData.OffenderProfileCurrentVictims && mEnrolleesData.OffenderProfileCurrentVictims.length && OrganizationState.IsPropertySupported(sama_property)){
                return true;
            }else {
                return false;
            }
        }
        return false;
    }
    //This Function will pair with mEnrolleeData.VictimCurrentOffenderVictims 
    StalkerController.PairingVictimsWithEnrollee = function(lVictims){
        if(lVictims && lVictims.length){
            var Associations = lVictims.map(function(v,i){
                var association = new SAMAOffenderAssociation();
                association.SAMAId = v.SamaPhoneNumber;
                association.EnrolleeId = v.SamaAssociateEnrolleeId;
                return association;
            });
            console.log('PairingVictimsWithEnrollee',Associations);
            WriteMultiple(Associations, function(){
                mActivityNotification.addNotification('Successfully saved Associations');
            }, failure, null, true);
            
        }
    };
    StalkerController.Organization_OnChange= uOrganization_OnChange;
    sama.SAMAPhoneNumberInUse = SAMAPhoneNumberInUse;
    sama.EnableStalkerMobileEdit_OnChange = EnableStalkerMobileEdit_OnChange;
    sama.Render = Render;
    window.uSAMARegistration = sama;
})();